import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Switch } from 'components/Form'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { useAbility } from 'providers/casl'
import { Schema } from './schema'

export const MultiFormatsForm = (): JSX.Element => {
  const { t } = useTranslation('features/adUnit')
  const { control } = useFormContext<Schema>()
  const ability = useAbility()
  const cannotUpdateAdUnit = ability.cannot('update', 'AdUnit')

  return (
    <Paper data-cy='section-multi-formats'>
      <SectionHeader
        subtitle={t('form.unfilledRecovery.multiFormats.description')}
        title={t('form.unfilledRecovery.multiFormats.title')}
        titleEndAdornment={
          <Switch
            control={control}
            disabled={cannotUpdateAdUnit}
            name='allowMultiformatEnabled'
            tooltip={{ content: t('form.unfilledRecovery.multiFormats.tooltip') }}
          />
        }
      />
    </Paper>
  )
}
